module.exports = __webpack_public_path__ + "img/attachment.64c02874.svg";